module.exports = "<div class=\"widgets\">\n  <div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{'row': widgetBlock.widgets.length > 1}\">\n    <div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{'col-md-6': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\">\n      <div ba-panel ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\">\n        <div ng-include=\"widget.url\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blur_admin/src/app/theme/components/widgets/widgets.html
// module id = 816
// module chunks = 2